import { CampaignContributionTerms } from "../campaign-contribution-rates";
import { CampaignTermsSections } from "./campaign-terms";
import type { CampaignView } from "./campaign-view";
import type { CampaignSchema } from "@/types";

/**
 * The Info tab in a phone-narrow column (the phone detail view, the overlay dock): the type's
 * guide leads, then its Info stack. Desktop keeps the guide in the sidebar and renders
 * `view.info` alone.
 */
export const CampaignInfoTab = ({ view }: { view: CampaignView }) =>
  view.guide ? (
    <div className="flex w-full flex-col gap-2">
      {view.guide}
      {view.info}
    </div>
  ) : (
    view.info
  );

/**
 * The T&C tab on every surface: the terms as our own sections (the rules, plus the scoring and
 * prizes cards — the same card + label as the Info tab's sections, so the three tabs read as one
 * system), then the contribution breakdown. The breakdown sits under T&C only: it is the
 * campaign's terms for what a wager is worth, and one home means a player is never unsure which
 * of two places to look. It renders nothing when no rates are configured.
 */
export const CampaignTermsTab = ({
  campaign,
}: {
  campaign: CampaignSchema;
}) => (
  <div className="flex w-full flex-col gap-2 lg:gap-4">
    <CampaignTermsSections campaign={campaign} />
    <CampaignContributionTerms campaign={campaign} />
  </div>
);
